import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_VOUCHER_DISCOUNT, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * A component that renders the voucher discount as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {Object} props.transaction - The transaction object (to get voucher code from protectedData)
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemVoucherDiscountMaybe = props => {
  const { lineItems, transaction, intl } = props;

  const voucherDiscountLineItem = lineItems.find(
    item => item.code === LINE_ITEM_VOUCHER_DISCOUNT && !item.reversal
  );

  // Get voucher code from transaction protectedData
  const voucherCode = transaction?.attributes?.protectedData?.voucherCode;

  return voucherDiscountLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        {voucherCode ? (
          <FormattedMessage id="OrderBreakdown.voucherDiscount" values={{ code: voucherCode }} />
        ) : (
          <FormattedMessage id="OrderBreakdown.voucherDiscountGeneric" />
        )}
      </span>
      <span className={css.itemValue}>{formatMoney(intl, voucherDiscountLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemVoucherDiscountMaybe;

